import { TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const EveeTextField = withStyles(styles)(TextField);

export default EveeTextField;
